<template>
  <div class="footer">
    <div class="footer-box">
      <div class="list-1"> บ้าน | เกี่ยวกับ </div>
      <div class="logo">แฟลชเงิน</div>
      <div class="list-1">บ้าน | เกี่ยวกับ </div>
    </div>

    <div class="copyright">
      © 2024 Relume. All rights reserved.
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-box {
    background: #0E0729;
    padding: 60px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      font-weight: 600;
      font-size: 34px;
      color: #FFFFFF;
    }

    .list-1 {
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
    }
  }

  .copyright {
    height: 76px;
    background: #000;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    line-height: 76px;
    text-align: center;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    send() {
      alert("send success");
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
